import { messages } from './messages';

export const getGoalStatusLabel = (status: string) => {
	switch (status) {
		case 'ON_TRACK':
			return messages.ON_TRACK;
		case 'OFF_TRACK':
			return messages.OFF_TRACK;
		case 'AT_RISK':
			return messages.AT_RISK;
		case 'PENDING':
			return messages.PENDING;
		case 'COMPLETED':
		case 'DONE':
			return messages.COMPLETED;
		case 'CANCELLED':
			return messages.CANCELLED;
		case 'PAUSED':
			return messages.PAUSED;
		case 'ARCHIVED':
			return messages.ARCHIVED;
		default:
			// Fallback to displaying the raw status text if it's unrecognized
			return {
				defaultMessage: status,
			};
	}
};
